import { graphql } from '../../graphql';

export const agenciesQuery = graphql(`
  query Agencies(
    $first: Int!
    $cursor: String
    $name: String
    $sort: AgencySort
  ) {
    agencies(first: $first, after: $cursor, name: $name, sort: $sort) {
      totalCount
      pageInfo {
        hasNextPage
        endCursor
      }
      nodes {
        id
        name
        logoUrl
        description
        itemsCount
        path
      }
    }
  }
`);

export const getSelectedAgencyQuery = graphql(`
  query SelectedAgency($slug: String!) {
    agency(slug: $slug) {
      id
      name
      description
      viewsCount
      contactAddress
      schedule
      phonesMasked
      latitude
      longitude
      logoUrl
      coverUrl
      itemsCount
      city {
        id
        name
      }
      path
      itemCategories {
        id
        pluralName
        slug
      }
    }
    categories {
      id
      title
      slug
      children {
        id
        title
        slug
      }
    }
  }
`);
